import $ from 'jquery'

declare global {
  interface Window {
    updateDarkTheme: () => void;
    setDarkThemeOnBody: () => void;
    sts_base_url: string;
    sts_current_url: string;
    sts_current_page: string;
    sts_current_theme: string;
    sts_current_theme_sub: string;
    sts_user_theme: string;
    site_id: string;
    finance_dollar_sign: string;
    select2_version: string;
    bootstrap_version: string;
  }
}

const updateDarkTheme = () => {
  if (typeof(window.sts_user_theme) !== 'undefined') {
    // Get user theme from global variable set in PHP
    localStorage.setItem('bluetrait_user_theme', window.sts_user_theme);
  }
  if ($('#dark_mode').is(':checked')) {
    localStorage.setItem('bluetrait_user_theme', 'dark');
  }
}

const setDarkThemeOnBody = () => {
  console.log('updateDarkTheme called', localStorage.getItem('bluetrait_user_theme'));
  // Global function to check if dark theme enabled
  if(localStorage.getItem('bluetrait_user_theme') && localStorage.getItem('bluetrait_user_theme') === 'dark') {
    $('html').attr('data-bs-theme', 'dark');
  } else {
    localStorage.setItem('bluetrait_user_theme', 'light');
    $('html').attr('data-bs-theme', 'light');
  }
}
window.updateDarkTheme = updateDarkTheme; // Expose function globally
window.setDarkThemeOnBody = setDarkThemeOnBody; // Expose function globally

$(function () {
  updateDarkTheme();
  setDarkThemeOnBody(); // Initialize dark theme based on localStorage
})

export default {
  updateDarkTheme,
  setDarkThemeOnBody
}
